if (window.location.hash) {
    if (window.location.hash.substring(1) === 'simple') {
        document.querySelector('body').classList.add('simple');
    }
}